import React, { useEffect, useRef, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
//icons
import { AiOutlineSearch } from 'react-icons/ai';
//slices
import { setBreadcrumbTitle } from 'slices/breadcrumbSlice';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import { InputCustom } from 'components/input';
import { UserContext } from 'context/userContext';

const SearchBar = ({ children, isDesktop, initialValues, onSearch }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation(['header']);
  const formikRef = useRef(null);
  const { setSearchData } = useContext(UserContext);
  const [formValues, setFormValues] = useState(initialValues);
  const { assignedLibrary } = useAssignedLibrary();

  useEffect(() => {
    setFormValues(initialValues);
  }, [initialValues]);

  const onSubmit = (values) => {
    const searchValue = values?.value ? values?.value : '';
    setSearchData({ value: searchValue, searchType: values?.searchType });
    dispatch(setBreadcrumbTitle(t('busqueda', { ns: 'backoffice' })));
    const { searchType, ...otherUrlParams } = values;
    const URLqueryParametersManager = new URLSearchParams({
      ...otherUrlParams,
      value: searchValue,
      products: searchValue,
    });
    const advancedSearchQueryParameters = URLqueryParametersManager.toString();
    navigate(`/${assignedLibrary}/lista/search?${advancedSearchQueryParameters}`);
    if (onSearch) {
      onSearch(searchValue, values?.searchType);
    }
  };

  useEffect(() => {
    if (formikRef.current && !location.pathname.includes('/lista/search')) {
      formikRef.current.resetForm();
    }
  }, [location]);

  const Input = ({ field, form, ...props }) => {
    return (
      <InputCustom
        icon={
          <button type="submit">
            <AiOutlineSearch className="icon-input d-lg-none icon-input-navbar-mobile" />
          </button>
        }
        {...field}
        {...props}
        onChange={field.onChange}
      />
    );
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={formValues || { value: '', searchType: '' }}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form role="search" className={isDesktop ? 'd-flex h-100' : ''}>
        <Field name="value" type="text" placeholder={t('buscarLibros')} component={Input} />
        {children}
      </Form>
    </Formik>
  );
};

SearchBar.propTypes = {
  children: PropTypes.node,
  isDesktop: PropTypes.bool,
  initialValues: PropTypes.object,
  onSearch: PropTypes.func,
};

export default SearchBar;
